import {
  ACQUIRE_POLICIES_START,
  ACQUIRE_POLICIES_SUCCESS,
  ACQUIRE_POLICIES_ERROR,
  ATTACH_CONNECT_POLICY,
  ATTACH_CONNECT_POLICY_SUCCESS,
  ATTACH_CONNECT_POLICY_ERROR,
  ATTACH_PUBLIC_PUBLISH_POLICY,
  ATTACH_PUBLIC_PUBLISH_POLICY_SUCCESS,
  ATTACH_PUBLIC_PUBLISH_POLICY_ERROR,
  ATTACH_SUBSCRIBE_POLICY,
  ATTACH_SUBSCRIBE_POLICY_SUCCESS,
  ATTACH_SUBSCRIBE_POLICY_ERROR,
  ATTACH_PUBLIC_RECEIVE_POLICY,
  ATTACH_PUBLIC_RECEIVE_POLICY_SUCCESS,
  ATTACH_PUBLIC_RECEIVE_POLICY_ERROR,
  SET_DEVICE_STATUS,
  INTERNET_CONNECTED_STATUS_CHANGED,
  MESSAGE_HANDLER_ATTACHED,
  ADD_SUBSCRIBED_TOPIC,
  ADD_SUBSCRIBED_TOPIC_ERROR,
  IOT_ERROR_OCCURRED,
  IOT_CONNECT_CALLBACK_START,
  IOT_CONNECT_CALLBACK_SUCCESS,
  IOT_CONNECT_CALLBACK_ERROR,
  IOT_CLOSE_CALLBACK_START,
  IOT_CLOSE_CALLBACK_SUCCESS,
  IOT_CLOSE_CALLBACK_ERROR,
  CLEAR_SUBSCRIBED_TOPICS,
  CLEAR_POLICIES,
  SET_IOT_CLIENT_ID,
  ON_NEW_MESSAGE_TRIGGERED
} from "../actions";

export const triggerOnNewMessage = items => ({
  type: ON_NEW_MESSAGE_TRIGGERED,
  payload: items
});

export const attachConnectPolicy = () => ({
  type: ATTACH_CONNECT_POLICY,
  payload: {}
});

export const attachConnectPolicySuccess = result => ({
  type: ATTACH_CONNECT_POLICY_SUCCESS,
  payload: result
});

export const attachConnectPolicyError = error => ({
  type: ATTACH_CONNECT_POLICY_ERROR,
  payload: error
});

export const attachPublicPublishPolicy = () => ({
  type: ATTACH_PUBLIC_PUBLISH_POLICY,
  payload: {}
});

export const attachPublicPublishPolicySuccess = result => ({
  type: ATTACH_PUBLIC_PUBLISH_POLICY_SUCCESS,
  payload: result
});

export const attachPublicPublishPolicyError = error => ({
  type: ATTACH_PUBLIC_PUBLISH_POLICY_ERROR,
  payload: error
});

export const attachSubscribePolicy = () => ({
  type: ATTACH_SUBSCRIBE_POLICY,
  payload: {}
});

export const attachSubscribePolicySuccess = result => ({
  type: ATTACH_SUBSCRIBE_POLICY_SUCCESS,
  payload: result
});

export const attachSubscribePolicyError = error => ({
  type: ATTACH_SUBSCRIBE_POLICY_ERROR,
  payload: error
});

export const attachPublicReceivePolicy = () => ({
  type: ATTACH_PUBLIC_RECEIVE_POLICY,
  payload: {}
});

export const attachPublicReceivePolicySuccess = result => ({
  type: ATTACH_PUBLIC_RECEIVE_POLICY_SUCCESS,
  payload: result
});

export const attachPublicReceivePolicyError = error => ({
  type: ATTACH_PUBLIC_RECEIVE_POLICY_ERROR,
  payload: error
});

export const internetConnectedStatusChanged = status => ({
  type: INTERNET_CONNECTED_STATUS_CHANGED,
  payload: status
});

export const acquirePolicies = () => ({ type: ACQUIRE_POLICIES_START, payload: {} });
export const acquirePoliciesSuccess = items => ({
  type: ACQUIRE_POLICIES_SUCCESS,
  payload: items
});

export const acquirePoliciesError = error => ({
  type: ACQUIRE_POLICIES_ERROR,
  payload: error
});

/**
 * Change device status
 *
 * @param {bool} status
 */
export const setDeviceStatus = status => ({
  type: SET_DEVICE_STATUS,
  payload: status
});

export const addSubscribedTopic = items => ({ type: ADD_SUBSCRIBED_TOPIC, payload: items });

export const addSubscribedTopicError = error => ({ type: ADD_SUBSCRIBED_TOPIC_ERROR, payload: error });

export const clearSubscribedTopics = () => ({ type: CLEAR_SUBSCRIBED_TOPICS, payload: null });

export const clearPolicies = () => ({ type: CLEAR_POLICIES, payload: null });

export const setMessageHandlerStatus = status => ({
  type: MESSAGE_HANDLER_ATTACHED,
  payload: status
});

export const setIotClientId = clientId => ({
  type: SET_IOT_CLIENT_ID,
  payload: clientId
});

export const iotErrorOccurred = error => ({
  type: IOT_ERROR_OCCURRED,
  payload: error
});

export const iotConnectCallbackStart = items => ({
  type: IOT_CONNECT_CALLBACK_START,
  payload: items
});

export const iotCloseCallbackStart = () => ({
  type: IOT_CLOSE_CALLBACK_START,
  payload: {}
});

export const iotConnectCallbackSuccess = () => ({
  type: IOT_CONNECT_CALLBACK_SUCCESS,
  payload: true
});

export const iotConnectCallbackError = error => ({
  type: IOT_CONNECT_CALLBACK_ERROR,
  payload: error
});

export const iotCloseCallbackSuccess = () => ({
  type: IOT_CLOSE_CALLBACK_SUCCESS,
  payload: true
});

export const iotCloseCallbackError = error => ({
  type: IOT_CLOSE_CALLBACK_ERROR,
  payload: error
});
